import type { LogAssessmentDetail } from './log-assessment.models';

const STORAGE_KEY = 'st-a-eye-log-assessments';

/** Slug id used by Logs routes (e.g. `Stolt Achievement` → `stolt-achievement`). */
export function logShipIdFromName(shipName: string): string {
  return String(shipName ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

export function readSavedLogAssessments(): Readonly<Record<string, LogAssessmentDetail>> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw) as Record<string, LogAssessmentDetail>;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export function saveLogAssessmentSnapshot(detail: LogAssessmentDetail): void {
  const all = { ...readSavedLogAssessments(), [detail.shipId]: detail };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}

export function getSavedLogAssessment(shipId: string): LogAssessmentDetail | null {
  const id = shipId.trim();
  if (!id) {
    return null;
  }
  return readSavedLogAssessments()[id] ?? null;
}
